// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ro-z","badgeLink":"So-z","category":"To-z"};